import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a4a2f06")

_pushScopeId("data-v-1a4a2f06")
const _hoisted_1 = { class: "form-item-intention-content" }
const _hoisted_2 = { class: "form-item-intention" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "form-item-left" }, [
  /*#__PURE__*/_createVNode("div", { class: "form-item-label" }, [
    /*#__PURE__*/_createTextVNode(" 意向车型"),
    /*#__PURE__*/_createVNode("span", { class: "required-flag" }, "*")
  ])
], -1)
const _hoisted_4 = {
  key: 0,
  src: "https://websitedn.yiautos.com/channel_quotation/v4/unchecked.png",
  class: "unchecked-intention"
}
const _hoisted_5 = {
  key: 1,
  src: "https://websitedn.yiautos.com/channel_quotation/v4/mul-checked.png",
  class: "unchecked-intention"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 暂无意向车型 ")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "choose-model-content"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "choose-model-icon",
  src: "https://websitedn.yiautos.com/channel_quotation/v4/choose-car.png"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "选择车型", -1)
const _hoisted_11 = {
  key: 1,
  style: {"padding":"0 0.3rem"}
}
const _hoisted_12 = { class: "car-model-info" }
const _hoisted_13 = { class: "model-info" }
const _hoisted_14 = { class: "model-name" }
const _hoisted_15 = { class: "model-footer" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, "指导价：", -1)
const _hoisted_17 = { class: "indicativePrice" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeIntention && _ctx.changeIntention(...args))),
        class: "form-item-right"
      }, [
        (!_ctx.hasIntentionCar)
          ? (_openBlock(), _createBlock("img", _hoisted_4))
          : (_openBlock(), _createBlock("img", _hoisted_5)),
        _hoisted_6
      ])
    ]),
    (!_ctx.hasIntentionCar)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          (!_ctx.carModel.name)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _createVNode("div", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.chooseModal && _ctx.chooseModal(...args)))
                }, [
                  _hoisted_9,
                  _hoisted_10
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.carModel.name)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("img", {
                    class: "model-img",
                    src: _ctx.carModel.brandAvatar
                  }, null, 8, ["src"]),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, _toDisplayString(_ctx.carModel.name), 1),
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", null, [
                        _hoisted_16,
                        _createVNode("span", _hoisted_17, _toDisplayString(_ctx.carModel.indicativePrice) + "万元", 1)
                      ]),
                      _createVNode("span", {
                        class: "change-model-btn",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.chooseModal && _ctx.chooseModal(...args)))
                      }, "更换车型")
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
})